import Vue from 'vue'
import App from './App.vue'
import router from './router'

import store from './store'
import { sync } from 'vuex-router-sync'
import axios from 'axios'
import VueAxios from 'vue-axios'
// import NProgress from 'vue-nprogress'
import config from './config'
import VueHead from 'vue-head'
import Global from './plugins/global'
import Toasted from 'vue-toasted'

import Buefy from 'buefy'

Vue.use(Buefy)

Vue.use(VueAxios, axios)

// Vue.use(NProgress, {
// 	latencyThreshold: 1000,
// 	router: false,
// 	http: false,
// })
// const nprogress = new NProgress({ parent: '.nprogress-container' })

Vue.use(VueHead, {
  separator: '-',
  complement: 'Poke website'
})

Vue.use(Global)

Vue.use(Toasted, {
  className: 'notification',
  duration: 4000,
  theme: 'primary',
})

Vue.config.productionTip = false

sync(store, router)

// event bus
const bus = new Vue()
Vue.prototype.$bus = bus

const _service = axios.create({
  baseURL: config.API.host,
  // headers: {
  // 	'Authorization': app.$auth.token()
  // }
})

const service = {
  get(url, data, uid) {
    this._checkCreate(uid)
    let r = _service.get(url, data)
    r.then(() => {
      this._complete(uid)
    }).catch(() => {
      this._complete(uid)
    })
    return r
  },
  post(url, data, uid) {
    this._checkCreate(uid)
    let r = _service.post(url, data)
    r.then(() => {
      this._complete(uid)
    }).catch(() => {
      this._complete(uid)
    })
    return r
  },
  check(uid) {
    if (typeof store.getters['requests/all'][uid] !== 'undefined') {
      return store.getters['requests/all'][uid]
    }
    return false
  },
  _checkCreate(uid) {
    if (uid) {
      if (typeof store.getters['requests/all'][uid] === 'undefined') {
        let d = {
          completed: false,
        }
        store.dispatch('requests/add', { uid: uid, data: d })
      } else if (store.getters['requests/all'][uid].completed) {
        let d = Object.create(store.getters['requests/all'][uid])
        d.completed = false
        store.dispatch('requests/edit', { uid: uid, data: d })
      }
    }
  },
  _complete(uid) {
    if (uid) {
      let d = Object.create(store.getters['requests/all'][uid])
      d.completed = true
      store.dispatch('requests/edit', { uid: uid, data: d })
    }
  },
}
_service.interceptors.request.use(function (config) {
  // if (nprogress.status <= 0) {
  // 	nprogress.inc(0.2)
  // } else {
  // 	nprogress.start()
  // }
  return config
}, function (error) {
  return Promise.reject(error)
})
_service.interceptors.response.use(function (response) {
  // nprogress.done()
  return response
}, function (error) {
  // nprogress.done()
  return Promise.reject(error)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})

// eslint-disable-next-line no-extend-native
String.prototype.toTitle = function () {
  if (this === '') {
    return this
  }
  return this[0].toUpperCase() + this.slice(1)
}
// eslint-disable-next-line no-extend-native
String.prototype.toUpper = function () {
  if (this === '') {
    return this
  }
  return this.toUpperCase()
}
// eslint-disable-next-line no-extend-native
String.prototype.toLower = function () {
  if (this === '') {
    return this
  }
  return this.toLowerCase()
}

export { store, service }
